import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckCircle2Icon } from 'lucide-react';
const items = ['Cómo Eliminar la Fascitis Plantar en 30 Días — Protocolo completo', 'Gift Card $6.000 JumpBox', 'Ebook Mentalidad de Acero', 'Guía de Calzado Inteligente'];
export function DoubleClose() {
  return <section className="py-6 md:py-10 px-4" data-id="element-42">
      <div className="max-w-3xl mx-auto text-center" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-44">
          <h2 className="text-xl md:text-2xl font-black uppercase text-white mb-4" data-id="element-45">
            ¿Llegaste hasta acá?{' '}
            <span className="text-neon" data-id="element-46">Ya sabés lo que necesitás.</span>
          </h2>

          {/* Full offer mockup */}
          <div className="flex justify-center mb-4" data-id="element-47">
            <img src="https://cdn.magicpatterns.com/uploads/hv1iCQ9pvK6xXNbCi7YShw/EBOOK_OFERTA_COMPLETA.webp" alt="Pack completo: Ebook + Guía de Calzado + Mentalidad Ganadora + Gift Card" className="w-full max-w-sm rounded-xl shadow-[0_0_30px_rgba(212,244,22,0.1)]" loading="lazy" decoding="async" data-id="element-48" />
          </div>

          <div className="bg-dark-card border border-dark-border rounded-xl p-5 mb-4 text-left" data-id="element-49">
            <div className="space-y-2 mb-4" data-id="element-50">
              {items.map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-51">
                  <CheckCircle2Icon className="w-4 h-4 text-neon shrink-0" data-id="element-52" />
                  <span className="text-white text-base md:text-lg" data-id="element-53">
                    {item}
                  </span>
                </div>)}
            </div>
            <div className="space-y-1 text-base md:text-lg" data-id="element-54">
              <p className="text-white" data-id="element-55">
                <span className="font-bold" data-id="element-56">Resultado:</span> Eliminás la
                fascitis desde la causa real.
              </p>
              <p className="text-white" data-id="element-57">
                <span className="font-bold" data-id="element-58">Precio:</span>{' '}
                <span className="text-pain line-through font-bold" data-id="element-59">
                  $71.000
                </span>{' '}
                →{' '}
                <span className="text-neon font-black text-xl" data-id="element-60">
                  $19.900 ARS
                </span>
              </p>
              <p className="text-white" data-id="element-61">
                <span className="font-bold" data-id="element-62">Riesgo:</span> Cero. O seguís igual,
                o en 30 días pisás diferente.
              </p>
            </div>
          </div>

          <motion.a href="https://jumpbox.ar/cart/51184272441639:1" onClick={() => (window as any).fbq?.('track', 'AddToCart')} animate={{
          scale: [1, 1.03, 1]
        }} transition={{
          repeat: Infinity,
          duration: 2
        }} className="inline-flex items-center justify-center gap-2 w-full py-4 bg-neon text-black font-heading font-black rounded-xl text-base md:text-lg uppercase tracking-wide hover:bg-neon-hover transition-colors shadow-[0_0_25px_rgba(212,244,22,0.2)]" data-id="element-63">
            EMPEZAR MI PROTOCOLO DE 30 DÍAS AHORA{' '}
            <ArrowRightIcon className="w-5 h-5" data-id="element-64" />
          </motion.a>
        </motion.div>
      </div>
    </section>;
}